import moment from 'moment'
import * as R from 'ramda'
import { DEFAULT_MOMENT_LANG } from 'constants/locale'
import availableMomentLocales from './availableLocales'

/*
** Appends to all the scripts in the DOM the one with the URL given
*/
export const scriptPromise = (url, locale) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.async = true
    script.onload = () => resolve(locale)
    script.onerror = reject
    script.src = url

    document.body.appendChild(script)
  })

const isValidValue = R.either(R.has(R.__, availableMomentLocales), R.equals('en'))

/*
** Moment locales don't have the same format than the one we use in the application.
** For instance there is no fr-FR, just fr. So this function helps to find the correct matching moment
** locale. And if there is no matching locale, it uses DEFAULT_MOMENT_LANG as a fallback.
*/
export const getMatchingMomentLocale = lc => R.pipe(
  R.defaultTo(DEFAULT_MOMENT_LANG),
  R.toLower,
  R.when(
    R.complement(isValidValue),
    R.pipe(
      R.split('-'),
      R.head,
      R.cond([
        [isValidValue, R.identity],
        [R.T, R.always(R.toLower(DEFAULT_MOMENT_LANG))]
      ])
    )
  )
)(lc)

export const getMomentLocale = lc => {
  const momentLocale = getMatchingMomentLocale(lc)
  const momentLocales = moment.locales()

  return {
    isAlreadyFetched: momentLocales.includes(momentLocale),
    momentLocale,
    url: `https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/${momentLocale}.js`
  }
}
